/* global BigInt */
import {moneyValue} from './moneyInput';
export function calculateAdminTrade(weight,price,totalValue,computedField='total'){
 if(!['total','weight','price'].includes(computedField))return null;
 const plainTotal=moneyValue(totalValue);
 if(computedField!=='total'){
  if(!/^\d+$/.test(plainTotal)||Number(plainTotal)<=0||Number(plainTotal)>9999999999999)return null;
  if(computedField==='weight'){const rate=moneyValue(price);if(!/^\d+$/.test(rate)||Number(rate)<=0||Number(rate)>9999999999999)return null;weight=String(Number((BigInt(plainTotal)*1000n+BigInt(rate)/2n)/BigInt(rate))/1000);}
  else{const grams=moneyValue(weight);if(!/^\d+(?:\.\d{1,3})?$/.test(grams)||Number(grams)<=0||Number(grams)>999999)return null;const units=BigInt(Math.round(Number(grams)*1000));price=String((BigInt(plainTotal)*1000n+units/2n)/units);}
 }
 const plainWeight=moneyValue(weight),plainPrice=moneyValue(price);
 if(!/^\d+(?:\.\d{1,3})?$/.test(plainWeight)||!/^\d+$/.test(plainPrice))return null;
 const grams=Number(plainWeight),rate=Number(plainPrice);
 if(grams<=0||grams>999999||rate<=0||!Number.isSafeInteger(rate)||rate>9999999999999)return null;
 const total=computedField==='total'?Number((BigInt(Math.round(grams*1000))*BigInt(rate)+500n)/1000n):Number(plainTotal);
 return total>0&&total<=9999999999999?{weight:grams,price_per_gram:rate,total}:null;
}
